export const imageConfig = {
  green: {
    arrow_top: require("../../../../assets/listening/green/arrow_top.png"),
    back: require("../../../../assets/listening/green/back.svg"),
    sub_arrow_right: require("../../../../assets/listening/green/sub-arrow-right.svg"),
    icon_save: require("../../../../assets/listening/green/icon_save.svg"),
    icon_theme: require("../../../../assets/listening/green/icon_theme.svg"),
    icon_volume: require("../../../../assets/listening/green/icon_volume.svg"),
    icon_accent: require("../../../../assets/listening/green/icon_accent.svg"),
    icon_pause:require("../../../../assets/listening/green/icon-pause.svg"),
    speed0_6: require("../../../../assets/listening/green/speed0_6.svg"),
    speed0_8: require("../../../../assets/listening/green/speed0_8.svg"),
    speed1: require("../../../../assets/listening/green/1.0_speed.svg"),
    speed1_2: require("../../../../assets/listening/green/1.2_speed.svg"),
    speed1_5: require("../../../../assets/listening/green/1.5_speed.svg"),
    title_icon: require("../../../../assets/listening/green/title_icon.svg"),
    audio_play: require("../../../../assets/listening/green/audio-play.svg"),
    audio_paused: require("../../../../assets/listening/green/audio_paused.svg"),
    arrow_line_active: require("../../../../assets/listening/green/arrow-line-active.svg"),
    subtract_gray: require("../../../../assets/listening/green/subtract-gray.svg"),
    subtract: require("../../../../assets/listening/green/subtract.svg"),
    icon_font: require("../../../../assets/listening/green/icon-font-size-white.svg"),
    play1: require("../../../../assets/listening/green/icon-record-active1.svg"),
    play2: require("../../../../assets/listening/green/icon-record-active2.svg"),
    step_next_active:require("../../../../assets/listening/green/step-next-active.svg"),
    step_prev_active:require("../../../../assets/listening/green/step-prev-active.svg"),
    step_end:require("../../../../assets/listening/green/step-end.svg"),
    icon_translate:require("../../../../assets/listening/green/icon-translate.svg"),
    icon_translate_active:require("../../../../assets/listening/green/icon-translate-active.svg"),
  },
  brown: {
    arrow_top: require("../../../../assets/listening/brown/arrow_top.png"),
    back: require("../../../../assets/listening/brown/brown-back.svg"),
    sub_arrow_right: require("../../../../assets/listening/brown/sub-arrow-right.svg"),
    icon_save: require("../../../../assets/listening/brown/icon_save.svg"),
    icon_theme: require("../../../../assets/listening/brown/icon_theme.svg"),
    icon_volume: require("../../../../assets/listening/brown/icon_volume.svg"),
    icon_accent: require("../../../../assets/listening/brown/icon_accent.svg"),
    icon_font: require("../../../../assets/listening/brown/icon_font.svg"),
    icon_pause:require("../../../../assets/listening/brown/icon_pause.svg"),
    speed0_6: require("../../../../assets/listening/brown/speed0_6.svg"),
    speed0_8: require("../../../../assets/listening/brown/speed0_8.svg"),
    speed1: require("../../../../assets/listening/brown/1.0_speed.svg"),
    speed1_2: require("../../../../assets/listening/brown/1.2_speed.svg"),
    speed1_5: require("../../../../assets/listening/brown/1.5_speed.svg"),
    title_icon: require("../../../../assets/listening/brown/title_icon.svg"),
    audio_play: require("../../../../assets/listening/brown/audio-play.svg"),
    audio_paused: require("../../../../assets/listening/brown/audio_paused.svg"),
    arrow_line_active: require("../../../../assets/listening/brown/arrow-line-active.svg"),
    subtract_gray: require("../../../../assets/listening/brown/subtract-gray.svg"),
    subtract: require("../../../../assets/listening/green/subtract.svg"),
    play1: require("../../../../assets/listening/brown/play1.svg"),
    play2: require("../../../../assets/listening/brown/play2.svg"),
    step_next_active:require("../../../../assets/listening/brown/step_next_active.svg"),
    step_prev_active:require("../../../../assets/listening/brown/step_prev_active.svg"),
    step_end:require("../../../../assets/listening/brown/step_end.svg"),
    icon_translate:require("../../../../assets/listening/brown/icon_translate.svg"),
    icon_translate_active:require("../../../../assets/listening/brown/icon_translate_active.svg"),
  },
  white: {
    arrow_top: require("../../../../assets/listening/white/arrow_top.png"),
    back: require("../../../../assets/listening/white/back.svg"),
    sub_arrow_right: require("../../../../assets/listening/white/sub-arrow-right.svg"),
    icon_save: require("../../../../assets/listening/white/icon_save.svg"),
    icon_theme: require("../../../../assets/listening/white/icon_theme.svg"),
    icon_volume: require("../../../../assets/listening/white/icon_volume.svg"),
    icon_accent: require("../../../../assets/listening/white/icon_accent.svg"),
    icon_font: require("../../../../assets/listening/white/icon_font.svg"),
    icon_pause:require("../../../../assets/listening/white/icon_pause.svg"),
    speed0_6: require("../../../../assets/listening/white/speed0_6.svg"),
    speed0_8: require("../../../../assets/listening/white/speed0_8.svg"),
    speed1: require("../../../../assets/listening/white/speed1.svg"),
    speed1_2: require("../../../../assets/listening/white/speed1_2.svg"),
    speed1_5: require("../../../../assets/listening/white/speed1_5.svg"),
    title_icon: require("../../../../assets/listening/white/title_icon.svg"),
    audio_play: require("../../../../assets/listening/white/audio_play.svg"),
    audio_paused: require("../../../../assets/listening/white/audio_paused.svg"),
    arrow_line_active: require("../../../../assets/listening/white/arrow_line_active.svg"),
    subtract_gray: require("../../../../assets/listening/white/subtract_gray.svg"),
    subtract: require("../../../../assets/listening/white/subtract.svg"),
    play1: require("../../../../assets/listening/white/play1.svg"),
    play2: require("../../../../assets/listening/white/play2.svg"),
    step_next_active:require("../../../../assets/listening/green/step-next-active.svg"),
    step_prev_active:require("../../../../assets/listening/green/step-prev-active.svg"),
    step_end:require("../../../../assets/listening/green/step-end.svg"),
    icon_translate:require("../../../../assets/listening/white/icon_translate.svg"),
    icon_translate_active:require("../../../../assets/listening/white/icon_translate_active.svg"),
  },
  blue:{
    arrow_top: require("../../../../assets/listening/blue/arrow_top.png"),
    back: require("../../../../assets/listening/blue/back.svg"),
    sub_arrow_right: require("../../../../assets/listening/blue/sub_arrow_right.svg"),
    icon_save: require("../../../../assets/listening/blue/icon_save.svg"),
    icon_theme: require("../../../../assets/listening/blue/icon_theme.svg"),
    icon_volume: require("../../../../assets/listening/blue/icon_volume.svg"),
    icon_accent: require("../../../../assets/listening/blue/icon_accent.svg"),
    icon_font: require("../../../../assets/listening/blue/icon_font.svg"),
    icon_pause:require("../../../../assets/listening/blue/icon_pause.svg"),
    speed0_6: require("../../../../assets/listening/blue/speed0_6.svg"),
    speed0_8: require("../../../../assets/listening/blue/speed0_8.svg"),
    speed1: require("../../../../assets/listening/blue/speed1.svg"),
    speed1_2: require("../../../../assets/listening/blue/speed1_2.svg"),
    speed1_5: require("../../../../assets/listening/blue/speed1_5.svg"),
    title_icon: require("../../../../assets/listening/blue/title_icon.svg"),
    audio_play: require("../../../../assets/listening/blue/audio_play.svg"),
    audio_paused: require("../../../../assets/listening/blue/audio_paused.svg"),
    arrow_line_active: require("../../../../assets/listening/blue/arrow_line_active.svg"),
    subtract_gray: require("../../../../assets/listening/blue/subtract_gray.svg"),
    subtract: require("../../../../assets/listening/blue/subtract.svg"),
    play2: require("../../../../assets/listening/blue/play2.svg"),
    play1: require("../../../../assets/listening/blue/play1.svg"),
    step_next_active:require("../../../../assets/listening/blue/step_next_active.svg"),
    step_prev_active:require("../../../../assets/listening/blue/step_prev_active.svg"),
    step_end:require("../../../../assets/listening/blue/step_end.svg"),
    icon_translate:require("../../../../assets/listening/blue/icon_translate.svg"),
    icon_translate_active:require("../../../../assets/listening/blue/icon_translate_active.svg"),
  },
  dark:{
    arrow_top: require("../../../../assets/listening/dark/arrow_top.png"),
    back: require("../../../../assets/listening/green/back.svg"),
    sub_arrow_right: require("../../../../assets/listening/dark/sub_arrow_right.svg"),
    icon_save: require("../../../../assets/listening/green/icon_save.svg"),
    icon_theme: require("../../../../assets/listening/green/icon_theme.svg"),
    icon_volume: require("../../../../assets/listening/green/icon_volume.svg"),
    icon_accent: require("../../../../assets/listening/green/icon_accent.svg"),
    icon_font: require("../../../../assets/listening/green/icon-font-size-white.svg"),
    icon_pause:require("../../../../assets/listening/dark/icon_pause.svg"),
    speed0_6: require("../../../../assets/listening/green/speed0_6.svg"),
    speed0_8: require("../../../../assets/listening/green/speed0_8.svg"),
    speed1: require("../../../../assets/listening/green/1.0_speed.svg"),
    speed1_2: require("../../../../assets/listening/green/1.2_speed.svg"),
    speed1_5: require("../../../../assets/listening/green/1.5_speed.svg"),
    title_icon: require("../../../../assets/listening/dark/title_icon.svg"),
    audio_play: require("../../../../assets/listening/dark/audio_play.svg"),
    audio_paused: require("../../../../assets/listening/dark/audio_paused.svg"),
    arrow_line_active: require("../../../../assets/listening/dark/arrow_line_active.svg"),
    subtract_gray: require("../../../../assets/listening/dark/subtract_gray.svg"),
    subtract: require("../../../../assets/listening/dark/subtract.svg"),
    play2: require("../../../../assets/listening/dark/play2.svg"),
    play1: require("../../../../assets/listening/dark/play1.svg"),
    step_next_active:require("../../../../assets/listening/dark/step_next_active.svg"),
    step_prev_active:require("../../../../assets/listening/dark/step_prev_active.svg"),
    step_end:require("../../../../assets/listening/dark/step_end.svg"),
    icon_translate:require("../../../../assets/listening/dark/icon_translate.svg"),
    icon_translate_active:require("../../../../assets/listening/dark/icon_translate_active.svg"),
  },
  speedActive:{
    speed0_6: require("../../../../assets/listening/speed0_6.svg"),
    speed0_8: require("../../../../assets/listening/speed0_8.svg"),
    speed1: require("../../../../assets/listening/speed1.svg"),
    speed1_2: require("../../../../assets/listening/speed1_2.svg"),
    speed1_5: require("../../../../assets/listening/speed1_5.svg"),
  }

};
